import { inject, Injectable } from '@angular/core';
import { DrawerService } from '@pf/shared-ui';
import {
    CpwCartEmptyDrawerComponent,
    CpwCartEmptyDrawerData,
} from '../components/cpw-cart-empty-drawer.component';

/**
 * Opens the shared "cart is empty" alert drawer. Use from any task screen
 * (packing, put-away) so the empty-cart prompt looks and behaves the same.
 */
@Injectable({ providedIn: 'root' })
export class CpwCartEmptyDrawerService {
    private readonly drawerService = inject(DrawerService);

    show(barcodes: string[]): void {
        const list = (barcodes ?? []).filter(Boolean);
        if (!list.length) {
            return;
        }
        this.drawerService.createTemplateDrawer({
            title: list.length > 1 ? 'Empty carts' : 'Empty cart',
            content: CpwCartEmptyDrawerComponent,
            data: { barcodes: list } as CpwCartEmptyDrawerData,
            placement: 'top',
            // Size to content — an acknowledgement alert shouldn't be a
            // full-height sheet (isMobile would force 85dvh).
            height: 'auto',
        });
    }
}
